import { get } from 'lodash/fp'

export const getNotificationsList = get('notifications')
